<template>
    <div>
        <div class="col-12 form-group">
            <label for="attributeGroupId">Group</label>
            <v-select
                v-model="attribute.attributeGroupId"
                :options="groups"
                :clearable="false"
                label="name"
                :reduce="option => option.id"
                :class="{
                    'is-invalid': hasError('attributeGroupId')
                }"
                :disabled="editMode"
            />
            <div class="invalid-feedback">
                {{ getError('attributeGroupId') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="value">Value</label>
            <input
                id="value"
                v-model="attribute.value"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('value')
                }"
                dir="auto"
                placeholder="Value"
            />
            <div class="invalid-feedback">
                {{ getError('value') }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            attribute: {},
            groups: []
        };
    },

    watch: {
        attribute() {
            this.$emit('input', this.attribute);
        }
    },

    async created() {
        this.attribute = { ...this.value };

        try {
            this.groups = await this.getAttributeGroups();
        } catch (error) {
            console.error(error);
            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getAttributeGroups: 'attributeGroups/index'
        }),

        hasError(key) {
            return (
                this.validation.attribute[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.attribute,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
